import { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';
import Divider from "@mui/joy/Divider";



import useRoles from "hooks/useRoles";
import AssistantOnly from 'components/AssistantOnly';
import useShiftHistory from 'hooks/useShiftHistory';

import { ShiftHistoryItemWithIdentity } from 'components/ShiftHistoryItem';

import {getIcon} from 'utils/misc';
import useUserIdentity from 'hooks/useUserIdentity';

const REQUIRED_ROLE = 'support';

const SupportShiftHistory = observer(() => {
    const { items, fetchListBySupport } = useShiftHistory();
    const { hasRole } = useRoles();
    const { currentIdentity } = useUserIdentity();
    const SupportIcon = getIcon('SupportAgent');

    const [fetched, setFetched] = useState(false);


    useEffect(() => {
        if (!fetched && hasRole(REQUIRED_ROLE) && currentIdentity.uuid) {
            console.log('fetching shift history');
            fetchListBySupport(currentIdentity.uuid);
            setFetched(true);
        }

    }, [currentIdentity.uuid, fetched, setFetched, fetchListBySupport, hasRole])

    if (!hasRole(REQUIRED_ROLE))
        return null;
    return (
        <Stack>
            <Typography level="title-md">
                Shift History <Chip>{items.length}</Chip>
            </Typography>
            <Typography
                level="title-sm"
            >See what the team has been doing.
            </Typography>
            <Typography
                level="body-xs"
                startDecorator={<SupportIcon color="warning" />}
            >Only the support team can see this list.
            </Typography>
            <Stack spacing={1}
                my={3}
                divider={<Divider />}
            >
                {
                    items.slice().sort((a, b) => {
                        return a.date_created > b.date_created ? -1 : 1;
                    }).map((item) =>
                        <ShiftHistoryItemWithIdentity
                            key={item.uuid}
                            item={item} />
                    )
                }
            </Stack>
        </Stack>
    );
});

const TeamStatusContainer = observer(() => {
    const { rolesNames } = useRoles();

    useEffect(() => {
        document.title = "Team Status";
    }, []);

    if (!rolesNames.includes('support'))
        return null;

    return (
        <AssistantOnly>
            <Stack>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={3}>

                    <SupportShiftHistory />
                </Stack>
            </Stack>
        </AssistantOnly>
    );
});

export default TeamStatusContainer;
